var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-y":"auto"}},[(_vm.$store.state.addRentalVehicleFormActive == false)?_c('div',[_c('v-card',{staticClass:"elevation-0"},[_c('property-rental-history',{attrs:{"property":_vm.property}})],1)],1):_c('div',[_c('add-property-rental-history')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }